import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

console.info("Bridgetown is loaded!")

// JavaScript to toggle mobile menu
const menuToggle = document.getElementById('menu-toggle');
const mobileMenu = document.getElementById('mobile-menu');
if (menuToggle && mobileMenu) {
  const menuButton = menuToggle.querySelector('button');
  menuToggle.addEventListener('click', () => {
    const isHidden = mobileMenu.classList.toggle('hidden');
    if (menuButton) {
      menuButton.setAttribute('aria-expanded', !isHidden);
    }
  });
}

const letters = "ABCDEFGHIJKLMNOPQRSTUVWXUZ ˁ˚ᴥ˚ˀ";

const matrixEffectCall = (event) => {
  let iterations = 0;
  const interval = setInterval(() => {
    event.target.innerText = event.target.innerText.split("")
                                  .map((letter, index) => {

                                    if (index < iterations) {
                                      return event.target.dataset.value[index];
                                    }

                                    return letters[Math.floor(Math.random() * 26)]

                                  })
                                  .join("");

    if (iterations >= event.target.dataset.value.length) clearInterval(interval);
    iterations += 1 / 3;
  }, 50);
}

const matrixEffect = (selector) => {

  document.querySelector(selector).onmouseover = event => {
    matrixEffectCall(event);
  }

}

if (document.location.pathname == '/') {
  matrixEffect('.cwd-logo');
  matrixEffect('.cwd-title');
}

/**
 * Click-to-reveal email protection.
 * Email is only decoded after a real user click — headless scrapers
 * that execute JS but don't simulate clicks never see the address.
 *
 * Usage in HTML:
 *   <a data-email="cHVibGljQGNhdHdhdGNoZG9nLmNvbQ==" href="#">Click to reveal email</a>
 *   <a data-email="cHVibGljQGNhdHdhdGNoZG9nLmNvbQ==" data-email-label="Hire Me" href="#">Hire Me</a>
 *
 * Encode with: btoa("you@example.com")
 */
document.querySelectorAll('[data-email]').forEach(el => {
  el.addEventListener('click', function reveal(e) {
    e.preventDefault();
    try {
      const email = atob(el.dataset.email);
      el.href = 'mailto:' + email;
      if (!el.dataset.emailLabel) {
        el.textContent = email;
      }
      el.removeEventListener('click', reveal);
      el.click();
    } catch (_) {
      // invalid base64 — leave element as-is
    }
  });
});
